import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { logout } from './slices/authSlice';
import AuthMonitor from './utils/authMonitor';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useLayout } from './context/LayoutContext'; // import the context

import { apiSlice } from './slices/apiSlice'; 


const App = () => {

  
  const dispatch = useDispatch();
  const { fluid } = useLayout(); // access fluid flag from context

  useEffect(() => {
    const expirationTime = localStorage.getItem('expirationTime');
    
    if (expirationTime) {
      const currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        dispatch(logout());
        dispatch(apiSlice.util.resetApiState()); 
      }
    }
  }, [dispatch]);

  return (
    <>
      <ToastContainer />
      <Header />
      <main className='py-3'>
        <AuthMonitor />
        <Container fluid={fluid}>
          <Outlet />
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default App;
